import { render, staticRenderFns } from "./BasicSelector.vue?vue&type=template&id=9f8800d2&scoped=true&"
import script from "./BasicSelector.vue?vue&type=script&lang=ts&"
export * from "./BasicSelector.vue?vue&type=script&lang=ts&"
import style0 from "./BasicSelector.vue?vue&type=style&index=0&id=9f8800d2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8800d2",
  null
  
)

export default component.exports